var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"jobApplicationFilter"}},[_c('SelectedFilters'),_c('transition',{attrs:{"name":"filters-fade"}},[(_vm.isFiltersPanelDisplayed)?_c('AdvancedFilter'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }